import React from "react";
import { Badge, ThemeIcon, Tooltip } from "@mantine/core";
import { IconPackageImport, IconRefresh } from "@tabler/icons-react";

interface Props {
  isReprinted?: boolean;
  lastStickerPrintedAt?: string;
  userName?: string;
  compact?: boolean;
}

const MEANING_LINE =
  "Received externally — already prepared, no cutting needed";

const buildTooltipLabel = (
  lastStickerPrintedAt?: string,
  userName?: string
): string => {
  if (!lastStickerPrintedAt) {
    return MEANING_LINE;
  }
  const printedAt = new Date(lastStickerPrintedAt).toLocaleString();
  const byUser = userName ? ` by ${userName}` : "";
  return `${MEANING_LINE}\nSticker printed ${printedAt}${byUser}`;
};

export const ReceivedExternalBadge: React.FC<Props> = ({
  isReprinted = false,
  lastStickerPrintedAt,
  userName,
  compact = false,
}) => {
  const tooltipLabel = buildTooltipLabel(lastStickerPrintedAt, userName);

  const indicator = compact ? (
    <ThemeIcon
      size="sm"
      variant="light"
      color="violet"
      radius="xl"
      aria-label="Received external"
    >
      {isReprinted ? (
        <IconRefresh size={14} />
      ) : (
        <IconPackageImport size={14} />
      )}
    </ThemeIcon>
  ) : (
    <Badge
      color="violet"
      variant="light"
      rightSection={isReprinted ? <IconRefresh size={10} /> : undefined}
    >
      Received External
    </Badge>
  );

  return (
    <Tooltip label={tooltipLabel} multiline withArrow>
      {indicator}
    </Tooltip>
  );
};
